const SENSITIVE_HEADER_KEYS = new Set([
  'authorization',
  'cookie',
  'set-cookie',
  'x-api-key',
  'token',
  'x-auth-token',
  'x-access-token',
  'x-csrf-token',
]);

const REDACTED = '[Filtered]';
const TRUNCATED = '[Truncated]';

/**
 * Deep-walks a serialized Sentry event object and replaces values at keys
 * matching known sensitive header names with `[Filtered]`. Objects beyond
 * depth 6 are replaced with `[Truncated]` rather than passed through
 * unredacted, so deeply nested sensitive keys cannot leak.
 * @param obj - The object to redact (any shape).
 * @param depth - Current recursion depth; capped at 6 to avoid stack overflow.
 * @returns A new object with sensitive values replaced.
 */
export const redactSensitiveKeys = (obj: unknown, depth = 0): unknown => {
  if (!obj || typeof obj !== 'object') return obj;

  if (depth > 6) return TRUNCATED;

  if (Array.isArray(obj))
    return obj.map((item) => redactSensitiveKeys(item, depth + 1));

  return Object.fromEntries(
    Object.entries(obj as Record<string, unknown>).map(([key, value]) =>
      SENSITIVE_HEADER_KEYS.has(key.toLowerCase())
        ? [key, REDACTED]
        : [key, redactSensitiveKeys(value, depth + 1)],
    ),
  );
};
